/* tslint:disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { AccountDeactivateModel } from '../../models/account-deactivate-model';

export interface AccountDeleteParams {
  accountGuid: string;
  body: AccountDeactivateModel;
}

export function accountDelete(
  http: HttpClient,
  rootUrl: string,
  params: AccountDeleteParams,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, accountDelete.PATH, 'delete');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  rb.path('accountGuid', params.accountGuid, { style: 'simple' });
  rb.body(params.body, 'application/json');

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter(
        (r: unknown): r is HttpResponse<unknown> => r instanceof HttpResponse,
      ),
      map((r: HttpResponse<unknown>) => r as StrictHttpResponse<void>),
    );
}

accountDelete.PATH = '/api/v1/accounts/{accountGuid}';
